import getAllNetworkPingPromises from "./getAllNetworkPingPromises";
import safeReduxStateNetworkErrorObject from "./safeReduxStateNetworkErrorObject";

const NETWORK_TEST_TIMEOUT = 60000

export default function runNetworkPingTest() {

    return new Promise(async function (resolve, reject) {
      try {
        // start a timeout to give it a time limit to run
        const NetworkCheckTimeout = setTimeout(() => reject(new Error("network test took too long.")), NETWORK_TEST_TIMEOUT);

        // create a promise for each ping 
        const networkCheckPromises = getAllNetworkPingPromises()

        let results;

        if(Promise.allSettled){
          // run the promises until all are settled, doesn't matter if succeed or rejected
          results = await Promise.allSettled(networkCheckPromises).then(responseArray => {
            return responseArray.map( result => {
              if(result.status === 'rejected'){
                return safeReduxStateNetworkErrorObject(result)
              }else{
                return result
              }
            })
          })
        }else{
          // for iOS 12 support, but won't provide all errors, only the first one failed.
          results = await Promise.all(networkCheckPromises).then(result => {
            if(result.status === 'rejected'){
              return result.reason
            }
            return result
          })
        }

        // report the test result
        if(results.every( result => result.status === 'fulfilled' || result.status === 'succeed')){ // iOS 12 status is succeed
          resolve("done")
        }else if(results.every( result => result.status === 'rejected')){
          reject({
            message: "all networks are unreachable.",
            details: results
          })
        }else{
          reject({
            message: "some networks are unreachable.",
            detail: results.filter( result => result.status === 'rejected')
          })
        }
        
        // clear the timeout after result comes in
        clearTimeout(NetworkCheckTimeout)
      } catch (err) {
        console.error("Network ping check caught an error", err)
        reject(err);
      }
    });
  }